import dayjs from "dayjs";
import BitrixCompanyDto, { ContractDto, ShortBitrixCompanyDto } from "../../dto/Dictionaries/BitrixCompanyDto";

export type ContractModel = Omit<ContractDto, "contractDate"> & {
  contractDate: dayjs.Dayjs;
};

export type BitrixCompanyModel = Omit<BitrixCompanyDto, "contracts"> & {
  contracts: ContractModel[];
};

export type ShortBitrixCompanyModel = ShortBitrixCompanyDto;

export class BitrixCompanyDataConverter {
  static convertContract(contract: ContractDto): ContractModel {
    return { ...contract, contractDate: dayjs(contract.contractDate) };
  }

  static convertContracts(contracts: Array<ContractDto> = []): Array<ContractModel> {
    return contracts.map((x) => this.convertContract(x));
  }

  static convertContractor(contractor: BitrixCompanyDto): BitrixCompanyModel {
    return {
      ...contractor,
      contracts: this.convertContracts(contractor.contracts),
    };
  }

  static convertContractors(contractors: Array<BitrixCompanyDto> = []): Array<BitrixCompanyModel> {
    return contractors.map((x) => this.convertContractor(x));
  }
}
